import { render } from "./StartAssessmentPage.vue?vue&type=template&id=95378424"
import script from "./StartAssessmentPage.vue?vue&type=script&lang=js"
export * from "./StartAssessmentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__